<template lang="html">
  <booking-event-item
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:detail="slotProps">
      <v-icon small class="mr-1">mdi-account-multiple</v-icon><span>{{slotProps.event.guests}} ({{slotProps.event.guests_children}})</span>
    </template>
  </booking-event-item>
</template>

<script>
import {BookingEventItem} from 'dync-booking'

export default {
  inheritAttrs: false,
  data() {
    return {};
  },
  components: {
    BookingEventItem
  }
}
</script>

<style lang="scss" scoped>
</style>
